import { useState, useEffect, useCallback } from 'react';

export const useDarkMode = () => {
  const [dark, setDark] = useState(() => {
    if (typeof document !== 'undefined') {
      return document.documentElement.classList.contains('dark');
    }
    return false;
  });

  useEffect(() => {
    // Check localStorage on mount (default to dark mode)
    const savedMode = localStorage.getItem('darkMode');
    const isDarkMode = savedMode === 'false' ? false : true; // Default to dark mode
    
    document.documentElement.classList.toggle('dark', isDarkMode);
    setDark(isDarkMode);

    // Listen for class changes on documentElement to sync across components
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isDark = document.documentElement.classList.contains('dark');
          setDark(isDark);
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  const toggleDarkMode = useCallback(() => {
    if (typeof document !== 'undefined') {
      const isDarkMode = !document.documentElement.classList.contains('dark');
      document.documentElement.classList.toggle('dark', isDarkMode);
      localStorage.setItem('darkMode', isDarkMode.toString());
      setDark(isDarkMode);
    }
  }, []);

  return { dark, toggleDarkMode };
};
